<template>
  <div>
    <h2 class="py-2">Gekoppelde integraties</h2>
    <b-row>
      <b-col :key="k" v-for="(i, k) in installed" cols="3">
        <b-card-group deck class="mb-0">
          <b-card no-body >
            <!-- INFORMAT -->
            <div v-if="i.type == 'm365'">
              <b-card-body>
                <b-card-title>
                  {{ integrations[i.type].title }}
                </b-card-title>
                <div class="d-flex justify-content-center my-2">
                  <img class="i-logo" :src="integrations[i.type].logo" />
                </div>
                <b-card-text v-if="i.domains">
                  <p class="text-center">
                    <strong>{{ i.domains.join(", ") }}</strong>
                  </p>
                </b-card-text>
              </b-card-body>
              <b-card-footer>
                <b-button
                  @click="editM365(i)"
                  class="w-100 mb-1"
                  variant="primary"
                >
                  <feather-icon icon="SettingsIcon" />
                  Instellingen
                </b-button>
                <b-button
                  @click="requestM365Sync()"
                  class="w-100"
                  variant="primary"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                  Synchroniseer
                </b-button>
              </b-card-footer>
            </div>
            <div v-else>
              <b-card-body>
                <b-card-title>
                  {{ integrations[i.type].title }}
                </b-card-title>
                <div class="d-flex justify-content-center my-2">
                  <img class="i-logo" :src="integrations[i.type].logo" />
                </div>
                <b-card-text>
                  <p v-if="i.type == 'informat'">
                    <strong>Instellingsnummer: </strong
                    >{{ i.instellingsnummer }}
                  </p>
                  <p v-if="i.type == 'm365'">
                    <strong>{{ i.domains.join(", ") }}</strong>
                  </p>
                  <p v-if="i.lastSync">
                    <strong>Laatste synchronisatie: </strong
                    >{{ formatDate(i.lastSync.seconds * 1000) }}
                  </p>
                </b-card-text>
              </b-card-body>
              <b-card-footer>
                <b-button
                  @click="requestSync(i.id)"
                  class="w-100"
                  variant="primary"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                  Synchroniseer
                </b-button>
              </b-card-footer>
            </div>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-alert v-if="installed.length == 0" show variant="primary" class="mb-50">
      <h4 class="alert-heading">Je hebt nog geen integraties geactiveerd!</h4>
      <div class="alert-body">Kies hieronder een integratie.</div>
    </b-alert>
    <h2 class="py-2">Integraties</h2>
    <b-row>
      <b-col :key="k" v-for="(i, k) in filteredIntegrations" cols="3">
        <b-card-group deck class="mb-0">
          <b-card no-body>
            <b-card-body>
              <b-card-title>
                {{ i.title }}
              </b-card-title>
              <div class="d-flex justify-content-center my-2">
                <img class="i-logo" :src="i.logo" />
              </div>
              <b-card-text>
                {{ i.text }}
              </b-card-text>
            </b-card-body>
            <b-card-footer>
              <b-button @click="handleClick(k)" class="w-100" variant="primary">
                <feather-icon icon="PlusIcon" />
                {{ i.btnText }}
              </b-button>
            </b-card-footer>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-modal
      title="Synchroniseren met Informat"
      v-model="openInformat"
      hide-footer
    >
      <informat @input="openInformat = false" />
    </b-modal>
    <b-modal
      title="Synchroniseren met Microsoft 365"
      v-model="openTeams"
      hide-footer
    >
      <teams :config="editIntegration" @input="openTeams = false" />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCardGroup,
  BCardBody,
  BCardText,
  BCardTitle,
  BCardFooter,
  BLink,
  BRow,
  BCol,
  BAlert,
  BButton,
  BModal,
} from "bootstrap-vue";

import Informat from "./Informat.vue";
import Teams from "./Teams.vue";
import { db, functions } from "@/firebase/firebaseConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  name: "integrations",
  components: {
    Informat,
    Teams,
    BCard,
    BCardBody,
    BCardGroup,
    BCardTitle,
    BCardText,
    BCardFooter,
    BLink,
    BRow,
    BCol,
    BButton,
    BModal,
    BAlert,
    FeatherIcon,
  },
  data() {
    return {
      openInformat: false,
      openTeams: false,
      installed: [],
      editIntegration: null,
      frequencies: {
        daily: "Dagelijks",
      },
      integrations: {
        informat: {
          title: "Informat",
          text:
            "Gebruik Informat als databron voor het dagelijks synchroniseren van leerlingen en klassen.",
          logo:
            "https://www.informat.be/static/img/logo-informat-schoolsoftware.svg",
          btnText: "Voeg integratie toe",
        },
        m365: {
          title: "Microsoft 365",
          text: "Synchroniseer met je Microsoft 365 & Teams omgeving.",
          logo:
            "data:image/svg+xml;base64,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",
          btnText: "Voeg integratie toe",
        },
      },
    };
  },
  created() {
    this.loadIntegrations();
  },

  computed: {
    hasm365() {
      var res = false;
      this.installed.forEach((i) => {
        if (i.type == "m365") res = true;
      });
      return res;
    },
    filteredIntegrations() {
      var res = { ...this.integrations, ...{} };
      if (this.hasm365) {
        delete res.m365;
      }
      return res;
    },
  },

  methods: {
    handleClick(i) {
      switch (i) {
        case "excel": {
          break;
        }
        case "informat": {
          this.editIntegration = null;
          this.openInformat = true;
          break;
        }
        case "m365": {
          this.editIntegration = null;
          this.openTeams = true;
          break;
        }
        default:
          break;
      }
    },
    editM365(i){
      this.openTeams = true;
      this.editIntegration = i;
    },
    loadIntegrations() {
      db.collection("organisations")
        .doc(this.$store.state.organisation.id)
        .collection("integrations")
        .onSnapshot((res) => {
          this.installed = [];
          res.docs.forEach((doc) => {
            this.installed.push({ ...doc.data(), id: doc.id });
          });
        });
    },
    formatDate(date) {
      return moment(date).format("dddd d MMM Y - h:mm");
    },
    requestM365Sync(id) {
      functions
        .httpsCallable("m365Sync")({
          orgId: this.$store.state.organisation.id,
        })
        .then((res) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Synchronisatie gestart!`,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        }).catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error!`,
              text: error.message,
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        });
      },

    requestSync(id) {
      functions
        .httpsCallable("requestNewSync")({
          intId: id,
          organisationId: this.$store.state.organisation.id,
        })
        .then((res) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Synchronisatie gestart!`,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error!`,
              text: error.message,
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
<style scoped>
.i-logo {
  max-height: 100px;
  margin: 0 auto;
}
</style>
